import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const ContrasenaFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='CONTRASEÑA' htmlFor='input-contrasena' md={3} alignRightAt='md' />
      <Col md={9}>
        <Field name='contrasena'>
          {({ field }) => (
            <Form.InputPassword
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='input-contrasena'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(ContrasenaFormGroup)
